import { render, staticRenderFns } from "./NoticeUser.vue?vue&type=template&id=9e27ba50"
import script from "./NoticeUser.vue?vue&type=script&lang=js"
export * from "./NoticeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports